<template>
  <div class="page_wrapper row p-0">
    <login-header
    :showLogin ="true" :showSignUp="true" @openModal="openModal"></login-header>
    <main class="col-xs-12 p-0">
      <div class="col-xs-12 p-0 d-flex justify-content-center">
        <div class="forgot-whitebox">
          <p class="page_header">{{$t('forgotYourPassword')}}?</p>
          <p class="forgot-card-desc">{{$t('forgotPasswordDesc')}}
          </p>
          <div class="forgot-container" :class="errorMessage ? 'pb-0' : 'pb-20'">
            <div class="forgot-input">
              <label for="email" class="float-left">{{$t('email')}}</label>
              <span class="required_astric">*</span>
              <input
                class="forgot-input-box-without-icon landing-input-field form-control"
                type="text"
                name="email"
                :placeholder="$t('enterEmail')"
                v-model="email"
                :class="{ 'field_error': errorMessage }"
              />
            </div>
            <div class="validation validation-danger" v-if="errorMessage">
              <!-- <img src="/static/images/icons/error-close.svg" class="downCarret" /> -->
              <span class="error-message">{{ errorMessage }}</span>
              <br />
            </div>
          </div>
          <div class="email-me-btn" :class="errorMessage ? 'email-me-error' : 'email-me'">
            <button
              class="email-btn button-success"
              type="button"
              @click="postEmail"
              :disabled="disableButton"
            >
            {{$t('emailMeInstructions')}}
            </button>
          </div>
          <div class="forgot-card-contact-desc text-center">
            <p>
              {{$t('forgotPasswordContactDescOne')}} <a>CDMHelp@ul.com</a><br/>{{$t('forgotPasswordContactDescTwo')}}
            </p>
          </div>
        </div>
      </div>
    </main>
    <login-footer @openModal="openModal"></login-footer>
    <TermsOfStatus :termsOfStatus="agreementType"></TermsOfStatus>
  </div>
</template>
<script>
import $ from 'jquery';
import { postForgotEmail } from '../../apis/passwords';
import { isValidMail } from '../Register/validator';
import LoginHeader from '../Login/LoginHeaderNew.vue';
import LoginFooter from '../Login/LoginFooterNew.vue';
import EventBus from '../../utils/event-bus';
import TermsOfStatus from '../Login/TermsOfStatus.vue';

export default {
  data() {
    return {
      agreementType: '',
      email: '',
      errorMessage: '',
      enableBtn: true,
      btnTxt: 'E-mail me instructions',
    };
  },
  components: {
    TermsOfStatus,
    LoginHeader,
    LoginFooter,
  },
  methods: {
    openModal(data) {
      console.log('openSaasModal');
      this.agreementType = data;
      $('#agreements').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async postEmail() {
      this.errorMessage = '';
      this.btnTxt = 'Submitting Form...';
      const result = await postForgotEmail(this.$i18n.locale, { email: this.email });
      if (result.status) {
        this.$router.push({
          name: 'login',
          params: {
            successMessage: this.$i18n.locale === 'Portuguese' ? 'E-mail enviado com sucesso' : 'Email sent successfully',
          },
        });
      } else if (!result.status) {
        if (this.$i18n.locale === 'Portuguese' && result.message === 'Invalid email/email not registered') {
          this.errorMessage = 'E-mail inválido/e-mail não cadastrado';
        } else if (this.$i18n.locale === 'Portuguese' && result.message === 'Your account has been deactivated.') {
          this.errorMessage = 'Sua conta foi desativada.';
        } else if (this.$i18n.locale === 'English' && result.message === 'Sua conta foi desativada.') {
          this.errorMessage = 'Your account has been deactivated.';
        } else {
          this.errorMessage = result.message;
        }
      }
      this.btnTxt = 'E-mail me instructions';
      EventBus.$on('languageChanged', (data) => {
        console.log('data: ', data);
        if (data === 'Portuguese') {
          if (this.errorMessage === 'Invalid email/email not registered') this.errorMessage = 'E-mail inválido/e-mail não cadastrado';
          else if (this.errorMessage === 'Your account has been deactivated.') this.errorMessage = 'Sua conta foi desativada.';
        }
        if (data === 'English') {
          if (this.errorMessage === 'E-mail inválido/e-mail não cadastrado') this.errorMessage = 'Invalid email/email not registered';
          else if (this.errorMessage === 'Sua conta foi desativada.') this.errorMessage = 'Your account has been deactivated.';
        }
      });
    },
  },
  computed: {
    disableButton() {
      if (isValidMail(this.email)) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.pb-40{
  padding-bottom: 40px;
}
.pb-0{
  padding-bottom: 0px;
}
.form-control::placeholder {
 font-weight: 400;
font-size: 16px;
line-height: 22px;
color: #999999;
}
.page_wrapper{
  margin-left: 0px;
  margin-right: 0px;
  position: relative;
  padding-bottom: 58px;
  min-height: 100vh;
  /* background-image: url('/static/images/logos/login_page_header_blur.svg'); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  overflow-x: hidden;
  background: #ebebeb;
}
.justify-content-center{
  justify-content: center;
}
main {
  padding: 92px 20px 30px 20px;

}
.forgot-whitebox{
  display: inline-block;
  margin-top: 112px;
  margin-bottom: 176px;
  padding: 10px;
  background:#FFFFFF;;
  /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25); */
  /* border-radius: 10px; */
  max-width: 684px;
  /* min-width: 684px; */
  /* min-height: 512px; */
  border: 1px solid #B3B3B3;
}
.page_header {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 42px;
  line-height: 57px;
  text-align: center;
  color: #333333;
  padding-top: 54px;
  margin-bottom: 24px;
  padding-left:3px
}
.forgot-card-desc {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #333333;
  margin-bottom: 0px;
  padding-left: 52px;
  padding-right: 51px;
}
.forgot-card-contact-desc{
  padding: 34px 49px 38px;
}
.forgot-card-contact-desc p{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #333333;
  margin-bottom: 0px;
}
.forgot-card-contact-desc a{
  color:#00518A;
}
.forgot-container{
  padding-top: 40px;
  padding-right: 38px;
  padding-left: 37px;
}
.forgot-input input:focus{
  outline:none !important;
  outline-width: 0 !important;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  border: 1px solid #0A99FF;
}
label {
  font-weight: 400;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  padding-right: 4px;
  margin: 0;
  color: #3e3e3e;
  padding-bottom: 7px;
}
.required_astric{
  color: #B00505;
  font-size: 16px;
}
.forgot-input-box-without-icon {
  padding: 6px 11px;
}
.landing-input-field.field_error{
  border: 1px solid #E12D33;
}
.landing-input-field {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid #4D4D4D;
  font-family: 'Open Sans' !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #4D4D4D !important;
}
.validation {
    /* margin-bottom: 13px; */
    /* padding: px 10px; */
    border: none;
    border-radius: 0px;
    padding-top:9px;
    padding-bottom: 12px;
}
.validation-danger {
    background-color: none !important;
    color:  #E12D33;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400 !important;
    font-size: 14px;
    line-height: 19px;

}
.email-me-btn{
  padding-left: 37px;
  padding-right: 38px;
}
.email-me-error {
  padding-top: 0px;
}
.email-me {
  padding-top: 19px;
}
.pb-0 {
  padding-bottom: 0px;
}
.mb-12 {
  margin-bottom: 12px;
}
.pl-9{
  padding-left: 9px;
}
.email-btn {
  padding: 9px 0px 8px 0px;
  width: 100%;
  background-color: #01518A !important;
  /* border-color: #01518A !important; */
  font-family: 'Open Sans' !important;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #FFFFFF !important;
  border-radius: 3px;
  border:none
}
.email-btn[disabled] {
  /* opacity: 1; */
  cursor: not-allowed;
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: rgba(1, 81, 138, 0.5) !important;
  /* border-color: rgba(1, 81, 138, 0.5) !important; */
  border:none !important;
}
.button-success[disabled]:hover{
   background-color: rgba(1, 81, 138, 0.5) !important;
  border-color: rgba(1, 81, 138, 0.5) !important;
}
.button-success:hover{
  background-color: #01518A !important;
  border-color: #01518A !important;
}
/* @media screen and (max-width: 640px) {
.forgot-whitebox {
    min-width: 90vw;
    margin-bottom: 0;
  }
}
@media screen and (max-width: 767px) {
  .forgot-container{
  padding-top: 40px;
  padding-right: 32px;
  padding-left: 32px;
}
.forgot-card-contact-desc{
  padding-left: 25px;
  padding-right: 24px;
}
.email-me-btn{
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 9px;
}
.forgot-whitebox {
  margin-top: 15px;
}
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .forgot-whitebox {
    margin-top: 60px;
  }
} */
</style>
